(function () {
    'use strict';

    angular
        .module('sodCommon')
        .factory('action-append-model', actionFunc);

    function actionFunc(lodash, $q, $injector) {
        /**
         * Action have 2 main functionality.
         *  1. Allow you to select the type of model (eventData, actionResponse),
         *  2. Allow you to append the model,
         *         to append the model. "target" field is required.
         *         if value is provided, value will be append to the return data.
         *         value takes precedent over source. Both cannot be used together for now.
         */
        return function(options, eventData, actionResponse) {
            return $q.when(run());
            function run() {
                let returnModel = getInitialModel();

                if (lodash.has(options, 'rules')) {
                    returnModel = options.rules.reduce(function(model, rule) {

                        const action = lodash.get(rule, 'action', 'append');
                        if (lodash.has(rule, 'target')) {
                            if (action === 'append') {

                                if (rule !== null) {
                                    lodash.set(model, rule.target, getValue(rule));
                                }
                            }
                            if (action === 'delete') {
                                delete model[rule.target];
                            }
                        }
                        if (action === 'merge') {
                            model = lodash.merge({}, model, getValue(rule));
                        }
                        return model;

                        // if (lodash.has(rule, 'target')) {
                        //     const action = lodash.get(rule, 'action', 'append');
                        //     if (action === 'append') {
                        //         const value = getValue(rule);
                        //         if (rule !== null) {
                        //             lodash.set(model, rule.target, value);
                        //         }
                        //     }
                        //
                        //     if (action === 'merge') {
                        //         model = lodash.merge({}, model, value);
                        //     }
                        //
                        //     if (action === 'delete') {
                        //         delete model[rule.target];
                        //     }
                        // }
                        // return model;
                    }, returnModel);
                }

                return returnModel;
            }

            function getInitialModel() {
                // actionResponse is defaultValue;
                const modelType = lodash.get(options, 'type', 'actionResponse');
                const isCopy = lodash.get(options, 'copy', false);
                let result = null;
                switch (modelType) {
                    case 'actionResponse':
                        result = actionResponse;
                        break;
                    case 'eventData':
                        result = eventData;
                        break;
                    case 'newModel':
                    default:
                        result = {};
                        break;
                }

                return (isCopy) ? angular.copy(result) : result;
            }

            function getValue(rule) {
                if (lodash.has(rule, 'value')) {
                    return mutateValue(rule, rule.value)
                } else {
                    const sourceType = lodash.get(rule, 'source_type', 'actionResponse');
                    let sourceModel = actionResponse;
                    switch (sourceType) {
                        case 'formData':
                            const formId = lodash.get(rule, 'form_id', null);
                            if (!formId) {
                                break;
                            }
                            var FormBuilderService = $injector.get('FormBuilderService');
                            sourceModel =  FormBuilderService.getModel(formId);
                            break;
                        case 'eventData':
                            sourceModel = eventData;
                            break;
                        case 'actionResponse':
                        default:
                            sourceModel = actionResponse;
                            break;
                    }
                    if (lodash.has(rule, 'source')) {
                        return mutateValue(rule, lodash.get(sourceModel, rule.source, null));
                    }
                    if (lodash.has(rule, 'useSourceType') && rule.useSourceType === true) {
                        return mutateValue(rule, sourceModel);
                    }
                }
                return null;
            }

            function mutateValue(rule, value) {
                let mutateType = lodash.get(rule, 'mutate', null);
                switch (mutateType) {
                    case 'fromKendoArray':
                        return lodash.values(value).slice(0, -4);
                    default: {
                        return value;
                    }
                }
            }
        };
    }
})();
